import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAppRoute } from '@/stores/app/route';
import { DEFAULT_FLSA_CONFIG } from '@/helpers/constants/flsaQuestions';

const VALID_FLSA_SECTIONS = [
  'eligibility',
  ...DEFAULT_FLSA_CONFIG.sections.map((s) => s.id),
  'summary',
];

// Used to sync the active section with the route query.
export const useFlsaSection = (options = {}) => {
  const fallbackSection = options.defaultSection || 'summary';

  const router = useRouter();
  const { route } = storeToRefs(useAppRoute());

  // The section from the route query, or the fallback section if not valid.
  const resolvedFlsaSectionFromQuery = computed(() => {
    const section = route.value?.query?.section;

    if (VALID_FLSA_SECTIONS.includes(section)) {
      return section;
    }

    return fallbackSection;
  });

  // The active section, synced with the route query.
  const activeFlsaSection = computed({
    get: () => resolvedFlsaSectionFromQuery.value,
    set: (nextSection) => {
      const normalizedSection = VALID_FLSA_SECTIONS.includes(nextSection)
        ? nextSection
        : fallbackSection;

      if (normalizedSection === resolvedFlsaSectionFromQuery.value) {
        return;
      }

      const currentQuery = route.value?.query || {};

      router.replace({
        query: {
          ...currentQuery,
          section: normalizedSection,
        },
      }).catch(() => {});
    },
  });

  return {
    activeFlsaSection,
    resolvedFlsaSectionFromQuery,
  };
};
